module.exports = __webpack_public_path__ + "img/static-brand1@2x.a973c930.png";